import React from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Alert, Typography } from '@mui/material';

import isProd from '~/utils/isProd';

const WORKFLOW_ITEM_LABELS: Record<string, string> = {
  'cm-checklist': 'CM Checklist',
  'deal-information': 'Deal Information',
  'hotel-proposal-pricing-tool': 'Hotel Proposal Pricing Tool',
  'rates-and-inventory': 'Rates and Inventory',
};

export default function OfferBuilderWorkInProgressPage() {
  const { pathname } = useLocation();
  const activePath = pathname.split('/').pop() ?? 'hotel-proposal-pricing-tool';
  const activeItem = WORKFLOW_ITEM_LABELS[activePath] ?? 'Hotel Proposal Pricing Tool';

  return (
    <>
      <Helmet>
        <title>{activeItem} | Offer Builder</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 3 }}>
        {activeItem}
      </Typography>
      {isProd() && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          Coming soon.
        </Alert>
      )}
    </>
  );
}
